// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60730da9","239":"e56147f9","455":"c686c475","488":"0655bc97"}[chunkId] + ".chunk.js";
};